// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/v0.1.1135/css/" + chunkId + "." + {"72":"cf904a0e","943":"cf904a0e"}[chunkId] + ".chunk.css";
};